/**
 *
 */
export default {
  ENABLE_ALARM_NOTICE: 'ENABLE_ALARM_NOTICE', // 是否启用报警提示
  SET_TITLE: 'SET_TITLE', // 设置标题和系统名称
  GET_ROUTES: 'GET_ROUTES', // 路由
  USER_INFO: 'USER_INFO', // 用户信息
  CHANGE_COLLAPSE: 'CHANGE_COLLAPSE', // 菜单折叠
  DEVICE_MODEL: 'DEVICE_MODEL', // 展示地图还是设备
  GET_DEVICE_TREE: 'GET_DEVICE_TREE', // 获取设备组织机构
  GET_AUTH_TASK: 'GET_AUTH_TASK', // 获取任务列表
  GET_OFFICES: 'GET_OFFICES', // 获取机构
  STATE_MODEL: 'STATE_MODEL', // 状态报告模式
  CLEAR_REPORT: 'CLEAR_REPORT', // 清空报告
  CHANGE_MAP_THEME: 'CHANGE_MAP_THEME', // 切换map主题
  DEVICE_MENU_COLLAPSE: 'DEVICE_MENU_COLLAPSE', // 设备列表切换
  CREATE_WEBSOCKET: 'CREATE_WEBSOCKET', // 创建socke实例和监听
  CLOSE_WEBSOCKET: 'CLOSE_WEBSOCKET', // 关闭ws
  LOCK_RECONNECT: 'LOCK_RECONNECT', // ws是否重连
  GET_HISTORY_DATA: 'GET_HISTORY_DATA', // 历史报警数据
  CLEAR_HISTORY_DATA: 'CLEAR_HISTORY_DATA', // 清空报警数据
  ALARM_VOICE: 'ALARM_VOICE', // 报警声音
  GET_AUTH_MENU: 'GET_AUTH_MENU', // 获取按钮权限
  ALARM_TYPE: 'ALARM_TYPE', // 报警类型
  MATERIAL_TYPE: 'MATERIAL_TYPE', // 物质类型
  BUSI_TYPE: 'BUSI_TYPE', // 统计类型
  SAVE_MUL_DEVICES: 'SAVE_MUL_DEVICES', // 存储多设备被选择的设备sn
  NETWORK: 'NETWORK', // 网络连接
  DEVICE_MODELS: 'DEVICE_MODELS', // 设备类型
  JUDGE_DEVICE_UNCONNECT: 'JUDGE_DEVICE_UNCONNECT', // 判断设备断开连接
  MODIFY_DEVICE_INFO: 'MODIFY_DEVICE_INFO', // 修改设备信息
  GET_PROFILE: 'GET_PROFILE', // 个性化
  ADD_SOCKET: 'ADD_SOCKET', // 窗口+1
  MAP_ZOOM: 'MAP_ZOOM', // 地图层级,

  SET_VUE_SOCKET_IO: 'SET_VUE_SOCKET_IO', // 创建socket实例并存储
  UPDATE_DEVICE_TREE: 'UPDATE_DEVICE_TREE',
  UPDATE_DEVICE_TREE_LANG: 'UPDATE_DEVICE_TREE_LANG',
  GET_DEVICE_DETAIL: 'GET_DEVICE_DETAIL',
  GET_DEVICE_REPORT: 'GET_DEVICE_REPORT',
  INTERVAL_UP: 'INTERVAL_UP', // 改变数据更新频率
  ADD_CACHE: 'ADD_CACHE', // keep-alive include 增加
  DEL_CACHE: 'DEL_CACHE', // keep-alive include 删除

  /** subDeviceMap 订阅多台设备数据详情 */
  SUB_DEVICE: 'SUB_DEVICE',
  UNSUB_DEVICE: 'UNSUB_DEVICE',

  /** admin 模块 */
  GET_VALID_DATA: 'GET_VALID_DATA', // 当请求完 profile接口后数据为有效状态 logo

  // device 模块
  /** 任务列表当前选择的设备id或最近点击的机构id，用于场景地图 */
  SET_MONITOR_MENU_ACTIVE: 'SET_MONITOR_MENU_ACTIVE',
  /* 设置任务列表默认选中菜单, 空值时有效 */
  SET_MONITOR_MENU_DEFAULT_ACTIVE: 'SET_MONITOR_MENU_DEFAULT_ACTIVE',
  /** 设置设备监控显示模式 */
  SET_MONITOR_MODE: 'SET_MONITOR_MODE',
  /** 设置设备监控配置，fontSize */
  SET_MONITOR_CONFIG: 'SET_MONITOR_CONFIG',

  // mqtt 模块
  /** 设置设备详情数据 */
  SET_DETAIL: 'SET_DETAIL',
  /** 清除设备详情数据 */
  CLEAR_DETAIL: 'CLEAR_DETAIL',
  /** 设置设备基础数据 */
  SET_BASIC_DATA: 'SET_BASIC_DATA',
  /** 清除设备基础数据 */
  CLEAR_BASIC_DATA: 'CLEAR_BASIC_DATA',
  /** MQTT 报警数据处理 */
  MQTT_ALARM: 'MQTT_/socket/alarm',
  /** MQTT 基础消息 */
  MQTT_BASIC_DATA: 'MQTT_/socket/basic',
  /** MQTT 报警数据已处置回调 */
  MQTT_ALARM_HANDLED: 'MQTT_/socket/alarm/dispose/finish',
  /** 移除指定IDS报警数据 */
  REMOVE_ALARM_BY_IDS: 'REMOVE_ALARM_BY_IDS',
  /** 清理报警数据 */
  CLEAR_ALARM_DATA: 'CLEAR_ALARM_DATA',

  /** 清理 静音报警设备 定时器 */
  SET_ALARM_TIMER: 'SET_ALARM_TIMER',
  CLEAR_ALARM_TIMER: 'CLEAR_ALARM_TIMER'
};
